import { render } from "./AccordeonBox.vue?vue&type=template&id=c1543d04"
import script from "./AccordeonBox.vue?vue&type=script&lang=js"
export * from "./AccordeonBox.vue?vue&type=script&lang=js"

import "./AccordeonBox.vue?vue&type=style&index=0&id=c1543d04&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__